'use client';
import React from 'react';
import { Button } from '@pezeshk-book/ui-kit';
import { useDispatch } from 'react-redux';
import { LaboratoryActions } from '@store/lab/lab-actions';
import { UsersActions } from '@store/users/users-action';
import getParseRoute from '@utils/helpers/parse-route';
import { useParams } from 'next/navigation';
import getDictionary from '@dictionaries-client';
import { LocaleTypes } from '@dictionaries-types';

const ServiceButton = ({ route, dispatchType = undefined, disabled = false } : {route: string, dispatchType?: 'lab'| 'consult', disabled?: boolean}) => {
  const dispatch = useDispatch();
  const { lang } = useParams<{lang: LocaleTypes}>();
  const { services: { buttons } } = getDictionary(lang);
  const handleClick = () => {
    if (dispatchType) {
      switch (dispatchType) {
        case 'lab':
          dispatch(LaboratoryActions.setShoppingCartInitialState());
          break;

        case 'consult':
          dispatch(UsersActions.setFilterItems({
            key: 'serviceType',
            value: 'مشاوره',
            id: '2',
          }));
          break;
      }
    }
  };

  return (
    <Button disabled={disabled} href={getParseRoute({ pathname: route, locale: lang })} onClick={handleClick} fontType={'bold'} className={'w-3/4 md:w-full'}>
      {buttons.order}
    </Button>
  );
};

export default ServiceButton;
